import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import TitlePages, { SubTitle } from "../../../layout/TitlePages";
import Breadcrumbs from "../../../layout/Breadcrumbs";
import SinExpandir from "../../../layout/HelperDataTable/SinExpandir";
import ListBadge from "../../../layout/ListBadge";
import { FilterYear, useSimpleTableConfig } from "../../../constants";
import { dataInfContable } from "../../../data/dataTransparencia";
import { dataCuentaPublicaNew } from "../../../data/2024/dataCuentaPublica";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { dataInfo2026 } from "../../../data/dataTransparencia";
import "../../../styles/TablaRegistros.css";

const baseUrl = "https://itetlax.org.mx/assets/pdf/transparencia/infContable";

const PdfLink = ({ url }) => {
  const fullUrl = `${baseUrl}/${url}`;
  return (
    <a href={fullUrl} target="_blank" rel="noopener noreferrer">
      <FontAwesomeIcon
        icon={faFilePdf}
        style={{ color: "#d32f2f", fontSize: "1.5rem" }}
      />
    </a>
  );
};

PdfLink.propTypes = {
  url: PropTypes.string.isRequired,
};

const Accordion = ({ idAccordion, clasName, children }) => {
  return (
    <div className={`accordion ${clasName}`} id={idAccordion}>
      {children}
    </div>
  );
};

const AccordionItem = ({
  flushID,
  titleItem,
  contentItem,
  isOpen,
  toggleItem,
}) => {
  return (
    <div className="accordion-item" style={{ fontSize: "18px" }}>
      <h2 className="accordion-header" id={`heading-${flushID}`}>
        <button
          className={`accordion-button ${isOpen ? "" : "collapsed"}`}
          type="button"
          onClick={toggleItem}
          aria-expanded={isOpen}
          aria-controls={`collapse-${flushID}`}
          style={{ fontSize: "18px" }}
        >
          {titleItem}
        </button>
      </h2>
      <div
        id={`collapse-${flushID}`}
        className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
        aria-labelledby={`heading-${flushID}`}
      >
        <div className="accordion-body" style={{ fontSize: "18px" }}>{contentItem}</div>
      </div>
    </div>
  );
};

const remuneracionMensualItems = [
  {
    year: "2025",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/1_2025.pdf",
  },
  {
    year: "2026",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/1.pdf",
  },
];

const padronProveedoresItems = [
  {
    year: "2025",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/2025.pdf",
  },
  {
    year: "2026",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/2026.pdf",
  },
];

const InformacionContable = () => {
  const [data, setData] = useState([]);
  const [openItems, setOpenItems] = useState({});

  useEffect(() => {
    document.title = "Información Contable y Financiera";
  }, []);

  useEffect(() => {
    console.log(
      "Datos cargados:",
      dataCuentaPublicaNew.find((item) => item.id === 36)?.items
    );
    setData(dataCuentaPublicaNew);
  }, []);
  const toggleItem = (id) => {
    setOpenItems((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const columns = useMemo(() => {
    return [
      {
        accessorKey: "id",
        header: "ID",
        footer: "ID",
        enableResizing: false,
        size: 80,
      },
      {
        accessorKey: "year",
        header: "AÑO",
        footer: "AÑO",
        enableResizing: false,
        Filter: FilterYear,
        size: 80,
      },
      {
        accessorFn: (row) => `${row.title} ${row.year}`,
        id: "title",
        header: "NOMBRE",
        footer: "NOMBRE",
        size: 200,
      },
      {
        accessorKey: "link",
        header: "DOCUMENTO",
        footer: "DOCUMENTO",
        Cell: ({ cell, row }) =>
          row.original.isAccordion ? null : (
            <PdfLink url={cell.getValue() + ".pdf"} />
          ),
        size: 100,
      },
    ];
  }, []);

  const renderAccordionContent = (row) => {
    return (
      <div className="p-3">
        <table className="table table-hover">
          <tbody>
            {row.original.items.map((item) => (
              <tr key={item.id}>
                <td style={{ width: "50px", textAlign: "center" }}>
                  <PdfLink url={`${row.original.link}${item.link}.pdf`} />
                </td>
                <td style={{ paddingLeft: "20px" }}>
                  {item.title}{" "}
                  {/* Esto mostrará EXACTAMENTE lo que pusiste en el data */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      <Breadcrumbs
        path={[
          { label: "Transparencia", url: "/Transparencia" },
          { label: "Información Contable y Financiera" },
        ]}
      />

      <TitlePages title="Cuenta Pública" subTitle="" />
      <SinExpandir />
      <br />
      <br />

      <div
        style={{ overflowX: "auto", maxWidth: "100%", marginBottom: "60px" }}
      >
        <MaterialReactTable
          columns={columns}
          data={data}
          enablePagination={true}
          initialState={{ pagination: { pageSize: 5 } }}
          muiTablePaperProps={{
            className: "tabla-registros-formal",
            elevation: 0,
          }}
          muiBottomToolbarProps={{
            className: "tabla-bottom-toolbar",
          }}
          muiTablePaginationProps={{
            rowsPerPageOptions: [5, 10, 25, 50, 100],
            showFirstButton: true,
            showLastButton: true,
          }}
          localization={MRT_Localization_ES}
          renderDetailPanel={({ row }) =>
            row.original.isAccordion ? renderAccordionContent(row) : null
          }
        />
      </div>

      <SubTitle title="Información Financiera" />


      {/* 1. Remuneración Mensual */}
      <div className="mt-4 mb-2">
        <h3 className="TITULOSINFOCONT">
          Remuneración Mensual
        </h3>
      </div>
      <div className="tabla-registros-formal MuiPaper-root w-100 mb-5">
        <div className="MuiTableContainer-root">
          <table className="table table-hover align-middle mb-0 w-100">
            <thead className="MuiTableHead-root">
              <tr className="MuiTableRow-root">
                <th className="MuiTableCell-head text-center" style={{ width: "120px" }}>AÑO</th>
                <th className="MuiTableCell-head">TÍTULO</th>
                <th className="MuiTableCell-head text-center" style={{ width: "140px" }}>DOCUMENTO</th>
              </tr>
            </thead>
            <tbody className="MuiTableBody-root">
              {[
                { year: "2025", title: "Remuneración Mensual", url: "https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/1_2025.pdf" },
                { year: "2026", title: "Remuneración Mensual", url: "https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/1.pdf" },
              ].map((item, idx) => (
                <tr key={idx} className="MuiTableRow-root" style={{ minHeight: "56px" }}>
                  <td className="MuiTableCell-body text-center">
                    <span className="mes-pill">{item.year}</span>
                  </td>
                  <td className="MuiTableCell-body">
                    <span style={{ fontWeight: 400, color: "#000000" }}>{item.title}</span>
                  </td>
                  <td className="MuiTableCell-body text-center">
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-inline-flex align-items-center justify-content-center"
                      title={'Descargar ' + item.title + ' ' + item.year}
                    >
                      <FontAwesomeIcon icon={faFilePdf} style={{ color: "#d32f2f", fontSize: "1.5rem" }} />
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* 2. Padrón de Proveedores */}
      <div className="mt-4 mb-2">
        <h3 className="TITULOSINFOCONT">
          Padrón de Proveedores
        </h3>
      </div>
      <div className="tabla-registros-formal MuiPaper-root w-100 mb-5">
        <div className="MuiTableContainer-root">
          <table className="table table-hover align-middle mb-0 w-100">
            <thead className="MuiTableHead-root">
              <tr className="MuiTableRow-root">
                <th className="MuiTableCell-head text-center" style={{ width: "120px" }}>AÑO</th>
                <th className="MuiTableCell-head">TÍTULO</th>
                <th className="MuiTableCell-head text-center" style={{ width: "140px" }}>DOCUMENTO</th>
              </tr>
            </thead>
            <tbody className="MuiTableBody-root">
              {[
                { year: "2025", title: "Padrón de Proveedores", url: "https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/2025.pdf" },
                { year: "2026", title: "Padrón de Proveedores", url: "https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/2026.pdf" },
              ].map((item, idx) => (
                <tr key={idx} className="MuiTableRow-root" style={{ minHeight: "56px" }}>
                  <td className="MuiTableCell-body text-center">
                    <span className="mes-pill">{item.year}</span>
                  </td>
                  <td className="MuiTableCell-body">
                    <span style={{ fontWeight: 400, color: "#000000" }}>{item.title}</span>
                  </td>
                  <td className="MuiTableCell-body text-center">
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-inline-flex align-items-center justify-content-center"
                      title={'Descargar ' + item.title + ' ' + item.year}
                    >
                      <FontAwesomeIcon icon={faFilePdf} style={{ color: "#d32f2f", fontSize: "1.5rem" }} />
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* 3. Presupuesto de egresos aprobado */}
      <div className="mt-4 mb-2">
        <h3 className="TITULOSINFOCONT">
          Presupuesto de egresos aprobado
        </h3>
      </div>
      <div className="tabla-registros-formal MuiPaper-root w-100 mb-5">
        <div className="MuiTableContainer-root">
          <table className="table table-hover align-middle mb-0 w-100">
            <thead className="MuiTableHead-root">
              <tr className="MuiTableRow-root">
                <th className="MuiTableCell-head text-center" style={{ width: "120px" }}>AÑO</th>
                <th className="MuiTableCell-head">TÍTULO</th>
                <th className="MuiTableCell-head text-center" style={{ width: "140px" }}>DOCUMENTO</th>
              </tr>
            </thead>
            <tbody className="MuiTableBody-root">
              <tr className="MuiTableRow-root" style={{ minHeight: "56px" }}>
                <td className="MuiTableCell-body text-center">
                  <span className="mes-pill">2026</span>
                </td>
                <td className="MuiTableCell-body">
                  <span style={{ fontWeight: 400, color: "#000000" }}>Presupuesto Aprobado 2026</span>
                </td>
                <td className="MuiTableCell-body text-center">
                  <a
                    href="https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/pre_apro_2026.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-inline-flex align-items-center justify-content-center"
                    title="Descargar Presupuesto Aprobado 2026"
                  >
                    <FontAwesomeIcon icon={faFilePdf} style={{ color: "#d32f2f", fontSize: "1.5rem" }} />
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default InformacionContable;
